import { createContext, useContext } from 'react'

import type { OperationalDriver } from './query/useOperationalDrivers'

export const SelectedBookingDriverContext = createContext<OperationalDriver | undefined>(undefined)
export const useSelectedBookingDriver = () => useContext(SelectedBookingDriverContext)
